import React, { useState, useEffect } from 'react'
import '../styles/payment.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEraser } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';

function Payment({ playersData, updateTableDataInParent, updateRowRequest, updateParentPaymentValue, updateParentIsPlus }) {
    const [paymentValue, setPaymentvalue] = useState(0);
    const [isPlus, setIsPlus] = useState(true);
    const [playerID, setPlayerID] = useState('');
    const RAKE = 0.1;
    const MAX_RAKE = 150;
    useEffect(() => {
        if (playersData && playersData.players && playersData.players.length > 0 && playerID === '') {
            setPlayerID(playersData.players[0].playerId);
        }
    }, [playersData.players, playerID]);

    useEffect(() => {
        updateParentPaymentValue(paymentValue)
    }, [paymentValue])

    useEffect(() => {
        updateParentIsPlus(isPlus)
    }, [isPlus])

    if (!playersData || !playersData.players) {
        return <div>Loading...</div>;
    }

    function handleNameChange(e) {
        let currentID = e.target.value
        setPlayerID(currentID)
    }

    function handlePaymentChange(e) {
        let value = e.target.value;
        setPaymentvalue(value)
    }

    function addPayment(amount) {
        amount = amount + (parseInt(paymentValue) || 0)
        setPaymentvalue(amount);
    }

    function doubleAmount() {
        const currentValue = parseInt(paymentValue) || 0;
        setPaymentvalue(currentValue * 2);
    }

    function divideByHalf() {
        const currentValue = parseInt(paymentValue) || 0;
        setPaymentvalue(Math.floor(currentValue / 2));
    }

    function calculateProfit(buyIn, outcome) {
        return parseInt(outcome - buyIn - calculateRake(buyIn, outcome));
    }

    function calculateRake(buyIn, outcome) {
        return outcome - buyIn > 0 ? Math.min(parseInt((outcome - buyIn) * RAKE), MAX_RAKE) : 0;
    }


    function updatePlayer() {
        if (isNaN(paymentValue) || paymentValue === 0) return;
        const updatedPlayers = playersData.players.map(player => {
            if (player.playerId == playerID) {
                const tempPaymentValue = paymentValue * (isPlus ? 1 : -1)
                const tempBuyinAmount = player.buyinAmount + tempPaymentValue;
                const updatedPlayer = {
                    ...player,
                    buyinAmount: tempBuyinAmount,
                    playerProfit: calculateProfit(tempBuyinAmount, player.playerOutcome),
                    playerRake: calculateRake(tempBuyinAmount, player.playerOutcome)
                }
                updateRowRequest(playersData.gameID, updatedPlayer, tempPaymentValue, true)
                return updatedPlayer;
            } else {
                return player;
            }
        })
        updateTableDataInParent(updatedPlayers);
    }




    return (
        <>
            <div className='paymentContainer'>
                {/* <select onChange={handleNameChange} value={playerID} >
                    {playersData.players.map((player, index) => (
                        <option key={index} value={player.playerId}>{player.playerName}</option>
                    ))}
                </select> */}
                <div className='doubleDivideContainer'>
                    <Button className='paymentBtns' variant='success' onClick={divideByHalf}>÷2</Button>
                    <div className='amountInputContainer'>
                        <input className='amountInput' type="text" onChange={handlePaymentChange} value={paymentValue}></input>
                        <FontAwesomeIcon className='eraseIcon' icon={faEraser} onClick={() => setPaymentvalue(0)} />
                    </div>
                    <Button className='paymentBtns' variant='success' onClick={doubleAmount}>×2</Button>
                </div>
                <div className='paymentButtonsContainer'>
                    <Button className='paymentBtns' variant={isPlus ? 'success' : 'danger'} onClick={() => addPayment(50)}>50</Button>
                    <Button className='paymentBtns' variant={isPlus ? 'success' : 'danger'} onClick={() => addPayment(100)}>100</Button>
                    <Button className='paymentBtns' variant={isPlus ? 'success' : 'danger'} onClick={() => addPayment(500)}>500</Button>
                    <Button className='paymentBtns' variant={isPlus ? 'success' : 'danger'} onClick={() => addPayment(1000)}>1000</Button>
                </div>
                <div className='plusOrMinus'>
                    <Button className='paymentBtns' variant='success' onClick={() => setIsPlus(true)}>+</Button>
                    <Button className='paymentBtns' variant='danger' onClick={() => setIsPlus(false)}>-</Button>
                </div>
                {/* <div className='submitContainer'>
                    <Button variant={isPlus ? 'success' : 'danger'} className='submit' onClick={() => updatePlayer()}>הוספה</Button>
                </div> */}
            </div>
        </>
    )
}

export default Payment